import { apiPath } from "@/api/api-path"
import api from "./service"
import qs from "qs"

// Site
export async function getAllSiteList() {
  return api
    .get(apiPath.getSiteList)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getSiteDetailById(siteId) {
  setTokenFromVuex()
  const path = apiPath.getSiteDetailById.replace("{siteId}", siteId)
  return api
    .get(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getAllDepartmentList(filterSiteId = []) {
  return api
    .get(apiPath.getAllDepartmentList, {
      params: {
        ...filterSiteId,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getDepartmentListBySiteId(siteId) {
  const path = apiPath.getDepartmentListBySiteId.replace("{siteId}", siteId)
  return api
    .get(path)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getSiteLocationList(filter) {
  const path = apiPath.getSiteLocationList
  return api
    .get(path, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getLocationBySiteId(siteId) {
  const path = apiPath.getLocationBySiteId.replace("{siteId}", siteId)
  return api
    .get(path)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function updateLocationBySiteId(siteId, locationList) {
  const path = apiPath.updateLocationBySiteId.replace("{siteId}", siteId)
  return api
    .put(path, locationList)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}
